import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import ConnectsView from './ConnectsView';

import { getQuickConnects, hideQuickConnects } from 'store/user/user.actions';
import { makeCall, addConnection, transfer } from 'store/call/call.actions';

import RootState from 'store/state';
import './connects.scss';
import { Channel } from '@missionlabs/smartagent-lib-shared/build/form-templates/form-template.schema';
import { transferChat } from 'store/chat/chat.actions';

interface Props extends ReturnType<typeof mapStateToProps> {
    getQuickConnects: typeof getQuickConnects;
    addConnection: typeof addConnection;
    makeCall: typeof makeCall;
    hideQuickConnects: typeof hideQuickConnects;
    transferChat: typeof transferChat;
    channel: Channel;
    transfer: (numer: string, name?: string, endpont?: any) => void;
}

class Connects extends PureComponent<Props> {
    readonly state = {
        filter: '',
    };
    componentDidMount() {
        this.props.getQuickConnects();
    }
    componentDidCatch(ex: Error) {}

    onSelect = (connect: any) => {
        const { inCall, canAddConnection, channel, chat } = this.props;
        if (channel === "CHAT") {
            this.props.transferChat(chat!.id, connect)

        } else {
            if (inCall) {
                console.log('adding connection');
                if (canAddConnection) {
                    this.props.transfer(connect.phoneNumber, connect.name, connect);
                } else {
                    console.log('Not in a state where we can add connection');
                }
                return;
            }
            this.props.makeCall(connect.phoneNumber, connect.name, connect);
        }
    };
    onFilter = (filter: string) => {
        this.setState({ filter });
    };
    filterConnects() {
        if (!this.props.connects) return [];
        const filter = this.state.filter;
        if (!filter) return this.props.connects;
        return this.sortConnects(
            this.props.connects.filter(
                c =>
                    c.name.toLowerCase().indexOf(filter.toLowerCase()) > -1 ||
                    (c.phoneNumber && c.phoneNumber.indexOf(filter) > -1)
            )
        );
    }

    sortConnects(connects: Array<any>) {
        return (
            connects && connects.sort((a, b) => a.name > b.name ? 1 : -1)
        );
    }

    render() {
        const { filter } = this.state;
        return (
            <ConnectsView
                connects={filter ? this.filterConnects() : this.sortConnects(this.props.connects)}
                onSelect={this.onSelect}
                onFilter={this.onFilter}
                filter={filter}
                channel={this.props.channel}
                onClose={this.props.hideQuickConnects}
            />
        );
    }
}

function mapStateToProps(state: RootState) {
    const inCall = !!state.call;
    const chat = state.chat.connections.find(c => state.contact?.ID === c.id);

    return {
        connects: inCall || !!chat
            ? state.user.connects || []
            : (state.user.connects && state.user.connects.filter(c => c.type === 'phone_number')) || [],
        inCall,
        chat,
        canAddConnection: inCall ? state.call.connections.length === 1 : false,
    };
}

export default connect(
    mapStateToProps,
    { getQuickConnects, hideQuickConnects, makeCall, addConnection, transferChat, transfer }
)(Connects);
